import { EnumWithDescription, ICustomEnumValue } from "./EnumWithDescription";

export enum HeightScaleEnum {
    In = 1 as any,
    Cm = 2 as any
}
class HeightScaleClass extends EnumWithDescription<HeightScaleEnum> {
    public readonly enum = HeightScaleEnum;
    public readonly enumName: string = "HeightScaleEnum";

    public readonly enumWithDescriptions: Map<string, ICustomEnumValue<HeightScaleEnum>> = new Map([
        [
            "In",
            {
                value: HeightScaleEnum.In,
                name: "in"
            }
        ],
        [
            "Cm",
            {
                value: HeightScaleEnum.Cm,
                name: "cm"
            }
        ]
    ]);
}

export const HeightScale = new HeightScaleClass();
